import PropTypes from 'prop-types';
import { useState, useEffect, useRef, useMemo } from 'react';

import copy from 'copy-to-clipboard';
import { Input, DefaultTooltip, InputGroup } from 'twyne-new.ui';

const propTypes = {
  value: PropTypes.any,
  children: PropTypes.any,
  label: PropTypes.any,
}

export default function URLView({ value, children, label, actions: Actions, isCopied, actionsProps, ...props }) {
  const [copied, setCopied] = useState(false)
  const [feedback, setFeedback] = useState('')
  const inputRef = useRef(null)
  const groupRef = useRef(null)

  const handleCopyURL = async () => {
    inputRef.current.select()
    const copied = copy(value)
    setCopied(copied)
  }

  useEffect(() => {
    setCopied(isCopied)
  }, [isCopied])

  useEffect(() => {
    if (copied) {
      setFeedback("Copied!")
      setTimeout(() => setCopied(false), 2000)
    } else {
      setFeedback(`Click to copy the ${label}`)
    }
  }, [copied, label])

  return <>
    <InputGroup tag={useTagRef('div', groupRef)}>
      {children}
      <Input {...props} readOnly value={value} tag={useTagRef('input', inputRef)} ref={inputRef} onClick={handleCopyURL} />
      <DefaultTooltip content='Copied!' side='left' open={copied}>
        <DefaultTooltip content={!copied && value && feedback} side='left' triggerProps={{ asChild: true }}>
          <div>
            <Actions {...actionsProps} />
          </div>
        </DefaultTooltip>
      </DefaultTooltip>
    </InputGroup>
  </>
}

const useTagRef = (Tag, ref) => useMemo(() => props => <Tag {...props} ref={ref} />, [])

URLView.propTypes = propTypes
URLView.defaultProps = {
  label: 'url',
}
